// import styled from 'styled-components'

import { useState } from "react";
import ProductAccordionContent from "./ProductAccordionContent";
import ProductAccordionPayments from "./ProductAccordionPayments";

interface P {
  rows: any
}
const ProductAccordion: React.FC<P> = ({ 
  rows,
  ...props
}: P) => {
  const [openIndex, setOpenIndex] = useState(-1);
  const rowStateGenerator = (index: number) => {
    return [
      index == openIndex,
      () => index == openIndex ? setOpenIndex(-1) : setOpenIndex(index)
    ]
  }

  return (
    <div {...props}>
      {rows?.map((row, index) => 
        <div key={row._key} >
          { row._type == 'productAccordion' && 
            <ProductAccordionContent 
              rowState={rowStateGenerator(index)}
              title={row.title} 
              content={row.content} 
            /> 
          }

          { row._type == 'payments' && 
            <ProductAccordionPayments 
              rowState={rowStateGenerator(index)}
            /> 
          }
        </div>
      )}
    </div>
  )
}

// const Wrapper = styled.div``

export default ProductAccordion